import { BaseRestService } from "./BaseRestService";
import { API_URL } from "./constants/api";

export const restService = new BaseRestService(API_URL);
